export default "__VITE_ASSET__BiCXoUx2__"